module.exports = __webpack_public_path__ + "img/pic_logo@2x.1187b65b.png";